'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _bindings = require('./bindings');

var _handlers = require('./handlers');

var init = exports.init = function init() {
  (0, _bindings.bindActions)();
};